import { motion } from "framer-motion";
import { CONTACT } from "./data";
import { INTRO } from "./Reveal";

const MSG = "Hello Zenura Metals, I'd like to discuss a metal scrap trade.";

export const WhatsAppButton = () => (
  <motion.a
    href={`https://wa.me/${CONTACT.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(MSG)}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with Zenura Metals on WhatsApp"
    data-testid="whatsapp-float-button"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: INTRO + 1.6, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.06 }}
    whileTap={{ scale: 0.94 }}
    className="group fixed bottom-5 right-5 z-[70] flex items-center gap-0 rounded-full bg-[#25D366] p-3.5 text-white shadow-[0_18px_40px_-12px_rgba(37,211,102,0.65)] sm:bottom-8 sm:right-8"
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-25 group-hover:hidden" />
    <svg viewBox="0 0 32 32" className="relative h-7 w-7" fill="currentColor" aria-hidden="true">
      <path d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.11.56 4.17 1.62 5.99L4 29l8.25-2.15a12.1 12.1 0 0 0 3.79.6C22.67 27.45 28 22.1 28 15.5 28 8.9 22.67 3 16.04 3Zm0 22.3c-1.2 0-2.38-.2-3.5-.6l-.5-.18-4.9 1.28 1.3-4.75-.32-.5a9.9 9.9 0 0 1-1.53-5.3c0-5.47 4.47-9.92 9.97-9.92 5.48 0 9.94 4.45 9.94 9.92 0 5.48-4.46 10.05-9.94 10.05Zm5.45-7.42c-.3-.15-1.77-.87-2.04-.97-.28-.1-.48-.15-.68.15-.2.3-.78.97-.96 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.58c-.2 0-.52.08-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.47 1.07 2.88 1.22 3.08.15.2 2.1 3.2 5.08 4.48.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Z" />
    </svg>
    <span className="relative hidden max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-[max-width,margin] duration-500 group-hover:ml-2 group-hover:mr-2 group-hover:max-w-[140px] sm:inline">Chat on WhatsApp</span>
  </motion.a>
);
